import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb, { generateBreadcrumbLD } from '@/components/feature/Breadcrumb';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

const teamMembers = [
  {
    name: '李志远',
    role: '创始人 & CEO',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Korean%20man%20portrait%20in%20modern%20business%20attire%2C%20confident%20expression%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=team-01&orientation=squarish',
    desc: '深耕漫画行业15年，致力于将优质韩漫带入中文市场。',
  },
  {
    name: '金秀雅',
    role: '内容总监',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Korean%20woman%20portrait%20in%20modern%20business%20attire%2C%20warm%20smile%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=team-02&orientation=squarish',
    desc: '资深内容策划人，严格把控每部作品的内容质量与翻译水准。',
  },
  {
    name: '朴俊昊',
    role: '技术负责人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Asian%20man%20portrait%20in%20casual%20tech%20attire%2C%20friendly%20expression%2C%20bright%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=team-03&orientation=squarish',
    desc: '全栈工程师，打造稳定流畅的漫画阅读平台体验。',
  },
  {
    name: '尹智恩',
    role: '运营主管',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Asian%20woman%20portrait%20in%20modern%20business%20style%2C%20professional%20expression%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=team-04&orientation=squarish',
    desc: '负责社区运营与读者服务，确保每一位读者都有最佳体验。',
  },
];

const milestones = [
  { year: '2020', title: '平台创立', desc: '韩漫漫画阅读平台正式上线，首批引入500部正版韩漫作品。' },
  { year: '2021', title: '百万用户', desc: '注册用户突破100万，成为中文韩漫阅读领域的领先平台之一。' },
  { year: '2022', title: '内容扩充', desc: '漫画库扩展至5000部以上，覆盖恋爱、奇幻、动作等全部主流分类。' },
  { year: '2023', title: '千万里程碑', desc: '平台累计阅读量突破10亿次，活跃用户超过500万。' },
  { year: '2024', title: '技术升级', desc: '全新阅读引擎上线，支持高清画质与极速加载，阅读体验全面升级。' },
  { year: '2025', title: '生态构建', desc: '推出创作者扶持计划，与韩国多家顶级漫画工作室建立独家合作关系。' },
  { year: '2026', title: '持续创新', desc: '持续引入最新韩漫作品，每日更新，打造最全正版韩漫阅读生态。' },
];

const faqs = [
  {
    q: '韩漫漫画网站上的漫画都是正版的吗？',
    a: '是的，平台上所有漫画作品均获得版权方正式授权，确保每一部作品均为正版资源，读者可以放心阅读。我们与韩国多家顶级漫画工作室和出版社建立了长期合作关系。',
  },
  {
    q: '如何免费阅读漫画？',
    a: '平台上每部漫画均设有免费试读章节（通常为前3-5话）。您可以通过首页的"免费漫画弹窗入口"快速进入免费阅读专区，或者浏览标有"免费"标签的作品，即可免费阅读。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们保持每日更新的节奏，热门连载漫画通常每周更新1-2话。您可以关注"最新更新"板块，追踪喜欢作品的更新动态。',
  },
  {
    q: '可以在手机上阅读吗？',
    a: '当然可以！平台采用响应式设计，完美适配手机、平板和电脑等各种设备。您可以在任何设备上享受流畅的漫画阅读体验。',
  },
  {
    q: '如何联系客服？',
    a: '您可以通过以下方式联系我们：发送邮件至 contact@manhuakr.com，或拨打客服热线 400-888-0000。工作时间为周一至周五 9:00-18:00。',
  },
];

export default function About() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <article>
            <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <section className="relative py-16 md:py-20 bg-gradient-to-br from-accent-500 via-primary-500 to-accent-700 overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-0 w-72 h-72 rounded-full bg-background-50 -translate-x-1/2 -translate-y-1/2" />
                <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-background-50 translate-x-1/4 translate-y-1/2" />
              </div>
              <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-8 text-center">
                <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4">
                  关于韩漫漫画
                </h1>
                <p className="text-background-200 text-base md:text-lg max-w-[700px] mx-auto leading-relaxed">
                  致力于打造最优质的韩漫漫画在线阅读平台，为华语读者带来高品质、正版授权的韩漫阅读体验
                </p>
              </div>
            </section>

            <div className="max-w-[1440px] mx-auto px-4 md:px-8">

              <section className="py-14 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
                  <div>
                    <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">
                      品牌介绍
                    </h2>
                    <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                      <p>
                        韩漫漫画（ManhuaKR）成立于2020年，是国内领先的韩漫漫画在线阅读平台。我们与韩国多家顶级漫画工作室和出版社建立了长期稳定的合作关系，确保平台上的每一部作品均为正版授权。
                      </p>
                      <p>
                        平台目前拥有超过<strong>10,000部正版韩漫作品</strong>，涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、日常等多元分类，满足不同读者的阅读偏好。我们的注册用户已突破<strong>500万</strong>，日活跃读者超过<strong>80万</strong>。
                      </p>
                      <p>
                        我们始终坚持<strong>"内容为王、读者至上"</strong>的理念，从漫画选品、翻译质量、阅读体验到社区运营，每一个环节都精益求精，致力于为华语读者提供最优质的韩漫阅读服务。
                      </p>
                    </div>

                    <div className="grid grid-cols-3 gap-6 mt-8">
                      {[
                        { value: '10,000+', label: '正版漫画' },
                        { value: '500万+', label: '注册用户' },
                        { value: '99.8%', label: '服务可用率' },
                      ].map(stat => (
                        <div key={stat.label} className="text-center p-4 rounded-xl bg-accent-50">
                          <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">
                            {stat.value}
                          </div>
                          <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="relative">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20modern%20open%20office%20space%20with%20creative%20team%20working%20on%20digital%20comics%2C%20large%20screens%20displaying%20webtoon%20art%2C%20warm%20lighting%2C%20collaborative%20atmosphere%2C%20professional%20creative%20studio%20style&width=600&height=400&seq=about-brand&orientation=landscape"
                      alt="韩漫漫画团队"
                      title="韩漫漫画 - 品牌介绍"
                      className="w-full rounded-2xl"
                    />
                    <div className="absolute -bottom-4 -right-4 w-32 h-32 rounded-2xl bg-accent-100/50 -z-10" />
                    <div className="absolute -top-4 -left-4 w-24 h-24 rounded-2xl bg-primary-100/50 -z-10" />
                  </div>
                </div>
              </section>

              <section className="py-14 md:py-20 border-t border-background-200">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
                  口碑与声誉
                </h2>
                <p className="text-sm text-foreground-500 text-center mb-10 max-w-[600px] mx-auto">
                  多年来，我们始终以优质内容和卓越体验赢得读者的信赖与好评
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
                  {[
                    {
                      quote: '韩漫漫画是我用过最好的漫画阅读平台，更新快、画质高、翻译也很棒，每天必刷！',
                      author: '小明同学',
                      role: '忠实读者 · 3年用户',
                      rating: 5,
                    },
                    {
                      quote: '正版授权让人放心，分类也很齐全。从恋爱到悬疑，各种类型都有，推荐给了很多朋友。',
                      author: '漫画爱好者',
                      role: 'VIP读者 · 2年用户',
                      rating: 5,
                    },
                    {
                      quote: '平台的阅读体验真的很好，加载快，界面简洁。免费试读的机制也很合理，先看再决定追不追。',
                      author: '追漫达人',
                      role: '活跃读者 · 1年用户',
                      rating: 5,
                    },
                  ].map((review, i) => (
                    <div key={i} className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                      <div className="flex items-center gap-0.5 mb-3">
                        {Array.from({ length: review.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                        "{review.quote}"
                      </p>
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                          <span className="text-accent-600 text-sm font-bold">{review.author[0]}</span>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">{review.author}</p>
                          <p className="text-xs text-foreground-500">{review.role}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[
                    { label: 'App Store 评分', value: '4.9', icon: 'ri-apple-fill' },
                    { label: '用户好评率', value: '99.2%', icon: 'ri-thumb-up-fill' },
                    { label: '合作出版社', value: '80+', icon: 'ri-building-2-fill' },
                    { label: '行业奖项', value: '12项', icon: 'ri-trophy-fill' },
                  ].map(item => (
                    <div key={item.label} className="p-4 rounded-xl bg-background-100 border border-background-200/70 text-center">
                      <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div className="text-xl font-bold text-foreground-900 font-heading">{item.value}</div>
                      <div className="text-xs text-foreground-500 mt-0.5">{item.label}</div>
                    </div>
                  ))}
                </div>
              </section>

              <section className="py-14 md:py-20 border-t border-background-200">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
                  发展历程
                </h2>
                <p className="text-sm text-foreground-500 text-center mb-10">
                  从创立至今，我们不断成长，每一步都离不开读者的支持
                </p>

                <div className="relative">
                  <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 md:-translate-x-px" />
                  <div className="space-y-8">
                    {milestones.map((item, i) => (
                      <div key={item.year} className={`relative flex items-start gap-6 md:gap-10 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                        <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                          <div className={`hidden md:block ${i % 2 === 0 ? 'md:pr-10' : 'md:pl-10'}`}>
                            <span className="text-xs font-bold text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
                              {item.year}
                            </span>
                            <h4 className="text-base font-semibold text-foreground-800 mt-2">{item.title}</h4>
                            <p className="text-sm text-foreground-500 mt-1">{item.desc}</p>
                          </div>
                          <div className="md:hidden">
                            <span className="text-xs font-bold text-accent-600 bg-accent-100 px-3 py-1 rounded-full">
                              {item.year}
                            </span>
                            <h4 className="text-base font-semibold text-foreground-800 mt-2">{item.title}</h4>
                            <p className="text-sm text-foreground-500 mt-1">{item.desc}</p>
                          </div>
                        </div>
                        <div className="absolute left-2 md:left-1/2 w-5 h-5 rounded-full bg-accent-500 border-4 border-background-50 md:-translate-x-1/2 z-10 mt-1" />
                        <div className="flex-1 hidden md:block" />
                      </div>
                    ))}
                  </div>
                </div>
              </section>

              <section className="py-14 md:py-20 border-t border-background-200">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
                  核心团队
                </h2>
                <p className="text-sm text-foreground-500 text-center mb-10">
                  一群热爱漫画、专注品质的伙伴
                </p>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
                  {teamMembers.map(member => (
                    <div key={member.name} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                      <img
                        src={member.avatar}
                        alt={member.name}
                        title={`${member.name} - ${member.role}`}
                        className="w-20 h-20 rounded-full mx-auto mb-3 object-cover"
                      />
                      <h4 className="text-sm font-semibold text-foreground-800">{member.name}</h4>
                      <p className="text-xs text-accent-600 font-medium mt-0.5">{member.role}</p>
                      <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{member.desc}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section className="py-14 md:py-20 border-t border-background-200">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500 text-center mb-10">
                  快速了解韩漫漫画平台的使用方式
                </p>

                <div className="max-w-[800px] mx-auto space-y-3">
                  {faqs.map((faq, i) => (
                    <details key={i} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                        <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                        <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:rotate-45 transition-transform">
                          <i className="ri-add-line"></i>
                        </span>
                      </summary>
                      <div className="px-5 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </section>

              <section className="py-14 md:py-20 border-t border-background-200">
                <div className="max-w-[800px] mx-auto">
                  <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3 text-center">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-500 text-center mb-10">
                    如有任何问题或合作意向，欢迎随时与我们联系
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
                    {[
                      { icon: 'ri-mail-line', label: '电子邮件', value: 'contact@manhuakr.com', href: 'mailto:contact@manhuakr.com' },
                      { icon: 'ri-phone-line', label: '客服热线', value: '400-888-0000', href: 'tel:400-888-0000' },
                      { icon: 'ri-map-pin-line', label: '公司地址', value: '北京市朝阳区望京SOHO T2 15层', href: '#' },
                    ].map(item => (
                      <a
                        key={item.label}
                        href={item.href}
                        className="flex flex-col items-center p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 text-center no-underline"
                        rel={item.href.startsWith('http') ? 'nofollow' : undefined}
                      >
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                          <i className={`${item.icon} text-xl`}></i>
                        </div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">{item.label}</h4>
                        <p className="text-sm text-foreground-500">{item.value}</p>
                      </a>
                    ))}
                  </div>

                  <div className="p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70">
                    <h3 className="text-lg font-heading text-foreground-900 mb-2">商务合作</h3>
                    <p className="text-sm text-foreground-600 mb-6">
                      如果您是漫画作者、出版社或广告合作方，欢迎通过以下方式联系我们：
                    </p>
                    <ul className="space-y-2 text-sm text-foreground-600">
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5"></i>
                        内容授权合作：licensing@manhuakr.com
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5"></i>
                        广告投放合作：ads@manhuakr.com
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5"></i>
                        品牌联名合作：brand@manhuakr.com
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>

            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify([
                  {
                    '@context': 'https://schema.org',
                    '@type': 'AboutPage',
                    name: '关于韩漫漫画',
                    description: '韩漫漫画成立于2020年，是国内领先的韩漫漫画在线阅读平台，拥有超过10,000部正版韩漫作品，注册用户突破500万。',
                    url: 'https://www.manhuakr.com/about',
                    isPartOf: {
                      '@type': 'WebSite',
                      name: '韩漫漫画',
                      url: 'https://www.manhuakr.com/',
                    },
                  },
                  {
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faqs.map(faq => ({
                      '@type': 'Question',
                      name: faq.q,
                      acceptedAnswer: {
                        '@type': 'Answer',
                        text: faq.a,
                      },
                    })),
                  },
                  generateBreadcrumbLD(breadcrumbItems),
                ]),
              }}
            />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}